// Retailer-specific signup wizard steps (hosted on the /register page).
// Shared modal steps (login/2FA/reset + email entry/verification) live in AuthFormType.
export enum RetailerFormType {
  Register = 'register',
  RetailerQualification = 'retailer-qualification',
  RetailerQualificationCategories = 'retailer-qualification-categories',
  SecondStep = 'second-step-form',
  ThirdStep = 'third-step-form',
  Categories = 'categories',
  ReferredConfirmed = 'referred-confirmed',
  Vat = 'vat',
  EarlyVerification = 'early-verification',
}
